// @ts-check
import api from 'utils/api';
import ReferralsActions from 'agent_portal/actions/ReferralsActions';

const actions = {
  fetchReferrals(fetchParams) {
    return api
      .get('/agent_portal/api/referrals', { params: fetchParams })
      .then(response => response.data);
  },

  updatePendingReferralsCount(total) {
    ReferralsActions.updatePendingReferralsCount({ pendingReferralsCount: total });
  },

  fetchReceivedFilterOptions() {
    return api.get('/agent_portal/api/referral_filters/received').then(response => response.data);
  },
};

export default actions;
